import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from './Icon';

const IconDropdown = ({ className, icon, title }) => icon ? (
    <Icon icon="ellipsis-horizontal" />
  ) : (
    <svg
      className={cn('c-icon', 'c-icon--dropdown', className)}
      viewBox="0 0 192 512"
    >
      <title className="c-icon__title">{title}</title>
      <polygon points="0,208 96,304 192,208" />
    </svg>
  );

export default IconDropdown;

IconDropdown.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
};

IconDropdown.defaultProps = {
  className: '',
  icon: '',
  title: '',
};
